import apiClient from '../../../../core/Api';
import { TagType, TagRequestParams } from '../../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class AuthorService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/authors`, reqParams).then((response) => response.data);

  static get = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/authors`).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deleteAuthors = async (ids: number[]): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/authors/${ids}`);
    return response.status === 204;
  };
}

export default AuthorService;
